import React, {Component} from 'react';
import EpicMenu from '../Menus/EpicMenu';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import PorSemana from './porSemana';
import NuevoRegistro from './mapEmpleados';
import { Icon, Modal } from 'semantic-ui-react';
import { AuthContext } from "../../Auth.js";
import DateUtilities from '../DateUtilities';
import moment from 'moment'

class PAsistencia extends Component{
	constructor(props){
		super(props);
		this.newRegistro = this.newRegistro.bind(this);
		this.cambiarEstado = this.cambiarEstado.bind(this);
		this.app= firebase;
		this.database = this.app.firestore().collection('Asistencia');
		this.dbPagos = this.app.firestore().collection('Pagos');
		const today = new Date();
        const date = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear()+' '+today.getHours()+':'+today.getMinutes();
		this.state = {
			semanas: [],
			fechaF:today,
			fecha: date,
			useModal: false,
			filtro: 0,
			opciones: []
		}
	}

	componentDidMount(){
		this.GetData()
	}
	setReference=()=>{
        let dbReference=firebase.firestore().collection('Asistencia')
        const firstOfYear=DateUtilities.getFirstDayOfYear()
        return dbReference.where('fecha', '>=', firstOfYear)
    }
	cambiarEstado = (id, estado) => {
		if (estado === 'Activa'){
			this.database.child(id).update({ estado: "Inactiva", });
		}
		else {
			this.database.child(id).update({ estado: "Activa", });
		};
	}
	getWeekAndYear=(date)=>{
        let momentDate=moment(date)
        let dayOfTheWeek=momentDate.day()
        let year=momentDate.year()
        let week=dayOfTheWeek>=4 
            ? moment(DateUtilities.addDays(date, 3)).week()
            : momentDate.week() 
        return`${week} ${year}`
    }
	GetData= async ()=>{
		this.unsubscribe=this.setReference().orderBy('fecha', "desc").onSnapshot(semanas=>{
            try{
                const semanasArray=[]
				const filtroArray = []
                let weekIndex=-1
                let empleadosIndexMap={}
                for(let i=0; i<semanas.size;i++){
                    const semana=semanas.docs[i]
                    const date=semanas.docs[i].data().fecha.toDate()
                    const weekAndYear=this.getWeekAndYear(date)
                    if(semanasArray.length===0 || semanasArray[weekIndex].weekAndYear!==weekAndYear){
                        semanasArray.push({weekAndYear:weekAndYear, employees:[], total:0})
                        filtroArray.push(weekAndYear)
						weekIndex++
                        empleadosIndexMap={}
                    }
                    const employee=semana.data().empleado
                    if(empleadosIndexMap[employee]===undefined){
                        semanasArray[weekIndex].employees.push({
                            employee:employee,
                            totalFaltas:0,
                            activities:[],
                        })
                        empleadosIndexMap[employee]=semanasArray[weekIndex].employees.length-1   
                    }
					if (semana.data().falta === 'falta'){
						semanasArray[weekIndex].employees[empleadosIndexMap[employee]].totalFaltas += 1
						semanasArray[weekIndex].total+= 1
						semanasArray[weekIndex].employees[empleadosIndexMap[employee]].activities.push({
							id:semana.id,
							empleado:semana.data().empleado,
							falta:'falta',
							hEntrada:"falta",
							hSalida:"falta",
							fecha:semana.data().fecha.toDate().toLocaleDateString(),
							asistencia:semana.data().asistencia,
						})
					} else {
						semanasArray[weekIndex].employees[empleadosIndexMap[employee]].totalFaltas += 0
						semanasArray[weekIndex].employees[empleadosIndexMap[employee]].activities.push({
							id:semana.id,
							empleado:semana.data().empleado,
							falta:"si",
							hEntrada:semana.data().hEntrada,
							hSalida:semana.data().hSalida,
							sueldo1: semana.data().sueldo1,
							horas1: semana.data().horas1,
							puesto1: semana.data().puesto1,
							sueldo2: semana.data().sueldo2,
							horas2: semana.data().horas2,
							puesto2: semana.data().puesto2,
							sueldoE: semana.data().sueldoE,
							horasE: semana.data().horasE,
							puestoE: semana.data().puestoE,
							fecha:semana.data().fecha.toDate().toLocaleDateString(),
							asistencia:semana.data().asistencia,
						})
					}
                }
                this.setState({
					opciones: filtroArray,
                    semanas:semanasArray
                })
            }
            catch(e){
                console.log(e)
            }
        })
    }
	newRegistro = async (asistencia) => {
		if (asistencia.pagoXhoras === 'si') {
			this.dbPagos.add({
				fecha: this.state.fechaF,
				empleado: asistencia.empleado,
				estado: 'pendiente',
				nombreActividad: 'sueldo por horas',
				unidades: 'horas',
				sueldo1: asistencia.sueldo1,
				horas1: asistencia.horas1,
				puesto1: asistencia.puesto1,
				sueldo2: asistencia.sueldo2,
				horas2: asistencia.horas2,
				puesto2: asistencia.puesto2,
				sueldoE: asistencia.sueldoE,
				horasE: asistencia.horasE,
				puestoE: asistencia.puestoE,
			})
		}
		this.database.add({
			fecha: this.state.fechaF,
			empleado: asistencia.empleado,
            falta: asistencia.falta,
			hEntrada: asistencia.hEntrada,
            hSalida: asistencia.hSalida,
            pagoXhoras: asistencia.pagoXhoras,
            sueldo1: asistencia.sueldo1,
			horas1: asistencia.horas1,
			puesto1: asistencia.puesto1,
			sueldo2: asistencia.sueldo2,
			horas2: asistencia.horas2,
			puesto2: asistencia.puesto2,
			sueldoE: asistencia.sueldoE,
			horasE: asistencia.horasE,
			puestoE: asistencia.puestoE,
		})
		.then(()=>{
			//alert('Registro Exitoso')
		})
		.catch(e=>{
			alert(e)
		})
	}
	modalAgregar = () => (
		<Modal 
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo Registro</button>}>
			<Modal.Header>
				<div>
					<div className='inline'>Registrar Asistencia</div>
					<button 
						className='borrar right' style={{padding: "0"}}
						onClick={() => this.changeUsModal(false)}>
						<Icon name='close' />
					</button>
				</div>
				<div className='description'>
					<div className='inline'>Por: {this.context.currentUser.name}</div>
					<div className='inline right'>{this.state.fecha}</div>
				</div>
			</Modal.Header>
			<Modal.Content>
				<NuevoRegistro 
				newRegistro={this.newRegistro}
				changeModal={this.changeUsModal} 
				fecha={this.state.fecha}
			/>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
	modificarContador=(input)=>{
		let contador = this.state.filtro
		if (input === "restar") {
			contador++
		}else if (input === "sumar") {
			contador--
		}else {
			contador = 0
		}
		this.setState({filtro: contador})
	}
	static contextType = AuthContext;
	render(){
		return (
		<div>
			<div className='header'>
				<EpicMenu />
				<div className='inline'>Asistencia</div>
				<div className="addNew" ><this.modalAgregar /></div>
			</div>
			<div className='filtro' > 
				<span>Semana:</span>
				<button className="previous" 
				disabled={this.state.filtro===this.state.opciones.length-1}
				onClick={()=>this.modificarContador("restar")}>
					<Icon name='angle left' />
				</button>
				<div className='counter'>{this.state.opciones[this.state.filtro]}</div>
				<button className="next" 
				disabled={this.state.filtro===0}
				onClick={()=>this.modificarContador("sumar")}>
					<Icon name='angle right' />
				</button>
			</div>
			<div className='body'>
				{
					this.state.semanas[this.state.filtro]?
					<PorSemana week={this.state.semanas[this.state.filtro]}/>
					:null
				}
			</div>
			<div className="footer" >
				<div className="footer1" ></div>
				<div className="footer2" ></div>
			</div>
		</div>
		);
	}
}

export default PAsistencia;